<mat-tab-group class="custom-mat-tab" *ngIf="report"
               (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedFieldSectionIndex">
  <mat-tab *ngFor="let section of report.definitionSections; let i = index" label="{{section.header}}">
    <ng-template mat-tab-label>
      <div class="custom-tab-header flex flex-row justify-start items-center">
        <div class="flex flex-row justify-start items-center">
          <div class="headers">{{section.header}}</div>
          <div class="tool-name">{{section.toolName}}</div>
        </div>
      </div>
    </ng-template>
    <div *ngIf="i === selectedFieldSectionIndex" class="content pos-relative m-30 flex flex-col">
      <div *ngIf="section.config.Editor=='DataSurveyFieldDefinitionSelectorComponent'" class="keno-grid-container">
        <particle-virtual-grid [sourceKey]="section?.config?.ConfigKey"
                               sortFieldKey="Name"
                               [invalidateSubject]="invalidateSubject"
                               (valueChanged)="onGridCellValueChange($event)"
        >
        </particle-virtual-grid>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>

